export default {
  setValue(state, { fieldName, payload }) {
    state[fieldName] = payload;
  },
  setUser(state, payload) {
    state.initPassword = payload.initial_password_change === 1 || false;
    state.user = payload || null;
    state.token = payload.token || null;
    state.isAdmin = Boolean(payload.admin);
    state.isRoot = Boolean(payload.root);
    state.isApprover = Boolean(payload.isApprover);
    state.isApproverNoRequest = Boolean(payload.isApproverNoRequest);
  },
  doLogout(state) {
    const loggedOutState = {
      initPassword: false,
      user: {},
      token: null,
      isAdmin: false,
      isRoot: false,
      isApprover: false,
      isApproverNoRequest: false,
      loadingPage: false,
      loadingRequest: false,
      settings: [],
      globalAlert: {},
    };
    Object.assign(state, loggedOutState);
  },
};
